// extracted by mini-css-extract-plugin
module.exports = {"container":"featureLeftRail_container__Odx0I","share":"featureLeftRail_share__jVdhS"};